/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import "./layout.scss"

import Header from "./header/header"
import BurgerNav from "./burger-nav/burger-nav"

import Footer from "./footer/footer"

function debounce(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  }
}

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const [drawerIsOpen, setDrawer] = useState(false)

  let classList = "layout"

  if (drawerIsOpen) {
    classList = "layout drawer-is-open"
  }

  const closeDrawer = () => {
    setDrawer(false)
  }

  const toggleDrawer = () => {
    setDrawer(!drawerIsOpen)
  }

  const handleResize = () => {
    debounce(closeDrawer(), 1000)
  }
  React.useEffect(() => {
    window.addEventListener("resize", handleResize, false)
  })

  return (
    <>
      <div className={classList}>
        <div className="page-container">
          <Header
            siteTitle={data.site.siteMetadata?.title || `Title`}
            onHamburgerClick={toggleDrawer}
            drawerIsOpen={drawerIsOpen}
          />
          <BurgerNav
            onLinkClick={closeDrawer}
            d
            className="nav-toggle hamburger hamburger--collapse"
            onClick={toggleDrawer}
            expanded={drawerIsOpen}
          ></BurgerNav>
          <main> {children}</main>
          <Footer siteTitle={data.site.siteMetadata?.title || `Title`} />
        </div>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
